import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const NeedTopHat = (props) => {
  const { name,
    onChangeParameter,
    inputId,
    tooltip,
    parameters,
    className,
    required,
    children,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img src={Spree.image_assets.top_hat} alt="Need a Top Hat" className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-9 col-lg-8 ps-3 ps-md-0 ps-lg-3">
        <RadioDualComponent
          label="Does your pallet need a top hat?"
          name={name}
          inputId={inputId}
          onChange={onChange}
          tooltip={tooltip}
          parameters={parameters}
          className={className}
          required={required}>
          {children}
        </RadioDualComponent>
      </div>
    </div>
  );
};

NeedTopHat.defaultProps = {
  inputId: 'pallet_need_top_hat',
  required: true,
  name: 'pallet_need_top_hat',
};

export default NeedTopHat;
